import GUI_Header from "./GUI_Header";
import GUI_InputTextSingle from "./GUI_InputTextSingle";
import GUI_Credit from "./GUI_Credit";
import GUI_Select from "./GUI_Select";
import T from "../TheTool";

function GUIset_DoubleCombo(props) {
	var title1 = T.getValue(props.title, "");
	var desc1 = T.getValue(props.desc, "");
	var guiTxt1 = T.getValue(props.guiTxt, "");
	var label1 = T.getValue(props.label1, "Input");
	var label2 = T.getValue(props.label2, "");
	var isNumOnly = T.getValue(props.isNumOnly, false);
	var txtButton = T.getValue(props.txtButton, "Click");
	var label1Align = T.getValue(props.label1Align, "left");
	var width1 = T.getValue(props.width1, 100);
	var width2 = T.getValue(props.width2, 100);
	var centerDesc = T.getValue(props.centerDesc, false);
	var paddingR2 = T.getValue(props.paddingR2, 0);
	//-----
	var label3 = T.getValue(props.label3, "");
	var width3 = T.getValue(props.width3, 100);
	var paddingR3 = T.getValue(props.paddingR3, 0);
	var hide2 = T.getValue(props.hide2, false);
	var hide3 = T.getValue(props.hide3, false);

	return (
		<div className="todoapp stack-large">
			<GUI_Header title={title1} desc={desc1} centerDesc={centerDesc} />
			<div style={{ marginTop: "3em" }}> </div>
			<GUI_InputTextSingle
				label={label1}
				text1={guiTxt1}
				text1Change={props.guiTxtChange}
				numberOnly={isNumOnly}
				width1={width1}
				fontSize2={24}
				width2={"100%"}
				labelAlign={label1Align}
			/>
			{hide2 ? (
				<></>
			) : (
				<GUI_Select
					label={label2}
					width1={width2}
					selecter_option={props.selecter_option}
					selectedOption={props.selectedOption}
					setSelectedOption={props.setSelectedOption}
					paddingR={paddingR2}
				/>
			)}
			{hide3 ? (
				<></>
			) : (
				<GUI_Select
					label={label3}
					width1={width3}
					selecter_option={props.selecter_option2}
					selectedOption={props.selectedOption2}
					setSelectedOption={props.setSelectedOption2}
					paddingR={paddingR3}
					marginT={10}
				/>
			)}
			<div style={{ display: "flex", marginLeft: "14%", marginRight: 0 }}>
				<button
					onClick={() => props.buttonClick()}
					className="btn btn__primary btn__lg"
					style={{ flex: 1, height: 50 }}
				>
					{txtButton}
				</button>
			</div>
			<div style={{ marginTop: "3em" }}> </div>
			{props.partResult}
			<GUI_Credit />
		</div>
	);
}
export default GUIset_DoubleCombo;
